
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
directives: {
TransferDom
},
components: {},
data () {
return {
user: {
userId: ''
},
prevImages: [],
previewOptions: {},
info: {
id: '',
title: '',
author: '',
time: '',
img: '',
imgList: [],
fcontent: '',
scontent: '',
url: ''
}
}
},
beforeRouteEnter (to, from, next) {
next(vm => {
vm.user = vm.$store.state.sx.user || vm.user
vm.$post('sys/about', {
userId: vm.user.userId
}, (res) => {
if (res.code === 200) {
for (let item in res.data) {
if (res.data[item] !== undefined && res.data[item] !== null) {
vm.info[item] = res.data[item]
}
}
for (let img in vm.info.imgList) {
vm.prevImages.push({
msrc: vm.info.imgList[img],
src: vm.info.imgList[img]
})
}
if (!vm.info.img && vm.info.imgList.length === 1) {
vm.info.img = vm.info.imgList[0]
}
}
})
})
},
methods: {
preview (index) {
this.$refs.prevImage.show(index)
}
}
}



// WEBPACK FOOTER //
// ./src/page/About.vue